import { render, staticRenderFns } from "./fotter.vue?vue&type=template&id=1304457b&scoped=true&"
import script from "./fotter.vue?vue&type=script&lang=js&"
export * from "./fotter.vue?vue&type=script&lang=js&"
import style0 from "./fotter.vue?vue&type=style&index=0&id=1304457b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304457b",
  null
  
)

export default component.exports